<ui-card [class.loading]="isLoading" [class.enhanced-card]="hasImprovedHomepageFlag">
    <div id="home-upcoming-events-viewer" #container>
        <ng-container *ngIf="!hasImprovedHomepageFlag; else improvedEventsView">
            <div class="day-container" *ngFor="let day of days">
                <div>{{ day.isToday ? ('today' | translate) : (day.date | i18nDate: 'short') }}</div>

                <div class="upcoming-event" *ngFor="let event of day.viewableEvents">
                    <div (click)="goToEmployeeProfile(event.employeeId)" class="avatar-container">
                        <app-avatar size="medium" [employee]="event.pseudoEmployee"></app-avatar>
                    </div>
                    <div (click)="goToEmployeeProfile(event.employeeId)" class="upcoming-event-text-container">
                        <div class="upcoming-event-title">
                            {{ event.upcomingEventTitle | translate: { name: event.fullName } }}
                        </div>
                        <div class="upcoming-event-description">
                            <ng-container
                                [ngTemplateOutlet]="eventDescriptionTemplate"
                                [ngTemplateOutletContext]="{ event }"
                            />
                        </div>
                    </div>
                </div>

                <div (click)="day.expand()" *ngIf="day.hasHiddenEvents" class="expansion-toggle">
                    +{{ day.numberOfHiddenEvents }} more event{{ day.numberOfHiddenEvents > 1 ? 's' : '' }}
                </div>

                <div (click)="day.shrink()" *ngIf="day.isShowingMoreEventsThanDefault" class="expansion-toggle">
                    {{ 'dashboard.showLess' | translate }}
                </div>

                <div class="no-events" *ngIf="day.isEmpty">
                    {{ 'dashboard.noEventsOn' | translate: { day: (day.date | i18nDate: 'shortWeekdayNoYear') } }}
                </div>
            </div>
        </ng-container>

        <ng-template #improvedEventsView>
            <div class="top-container">
                <h2 class="events-title">{{ 'dashboard.eventsTitle' | translate }}</h2>

                <div class="actions-container flex">
                    <div class="all-departments margin-right-1">
                        <ui-button
                            id="events-filter"
                            size="min-padding"
                            [matMenu]="filter"
                            aria-label="{{ 'dashboard.eventsTitle' | translate }} {{ 'filter' | translate }}"
                        >
                            <mat-icon
                                [svgIcon]="eventService.filterOptions ? 'filterListActive' : 'filterList'"
                            ></mat-icon>
                        </ui-button>

                        <mat-menu #filter xPosition="before" class="department-list" aria-labelledby="events-filter">
                            <button (click)="onDepartmentFilter('all')" mat-menu-item>
                                {{ 'dashboard.allDepartments' | translate }}
                            </button>
                            <button
                                (click)="onDepartmentFilter(department.id)"
                                *ngFor="let department of allDepartments"
                                mat-menu-item
                            >
                                {{ department.name | translate }}
                            </button>
                        </mat-menu>
                    </div>
                    <div *ngIf="canAccessCalendar" class="calender-icon">
                        <ui-button (click)="onCalendarClick()" size="min-padding" [matMenu]="filter">
                            <mat-icon svgIcon="calendar"></mat-icon>
                        </ui-button>
                    </div>
                </div>
            </div>

            <div class="chip-container" aria-label="event-type-tabs">
                <app-chip-filters
                    aria-label="{{ 'dashboard.eventsTitle' | translate }} {{ 'filters' | translate }}"
                    [chips]="chips"
                    (chipSelected)="getSelectedEvents($event)"
                ></app-chip-filters>
            </div>

            <div class="events-list">
                <div class="day-container enhanced" *ngFor="let day of firstTwoDays">
                    <div class="date">
                        {{ day.isToday ? ('today' | translate) : (day.date | i18nDate: 'shortWeekdayNoYear') }}
                    </div>

                    <div
                        role="list"
                        [attr.aria-label]="
                            day.isToday ? ('today' | translate) : ('next' | translate) + ('day' | translate)
                        "
                    >
                        <div
                            class="upcoming-event upcoming-event-enhanced"
                            role="listitem"
                            attr.aria-labelledby="event-{{ i }}-title"
                            *ngFor="let event of day.viewableEvents; let i = index"
                        >
                            <div class="upcoming-event-card">
                                <div class="flex">
                                    <div (click)="goToEmployeeProfile(event.employeeId)" class="avatar-container">
                                        <app-avatar size="medium" [employee]="event.pseudoEmployee"></app-avatar>
                                    </div>
                                    <div
                                        (click)="goToEmployeeProfile(event.employeeId)"
                                        class="upcoming-event-text-container"
                                    >
                                        <div class="upcoming-event-title" id="event-{{ i }}-title">
                                            {{ event.upcomingEventTitle | translate: { name: event.fullName } }}
                                        </div>
                                        <div class="upcoming-event-description">
                                            <ng-container
                                                [ngTemplateOutlet]="eventDescriptionTemplate"
                                                [ngTemplateOutletContext]="{ event }"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <img
                                    *ngIf="event.type === 'birthday'"
                                    class="event-icon"
                                    src="/assets/illustrations/cake.png"
                                />
                                <img
                                    *ngIf="event.type === 'anniversary' || event.type === 'newHire'"
                                    class="event-icon"
                                    src="/assets/illustrations/confetti.png"
                                />
                            </div>
                        </div>
                    </div>
                    <ui-button type="link" (click)="day.expand()" *ngIf="day.hasHiddenEvents" class="expansion-toggle">
                        {{
                            'dashboard.showMoreEvents'
                                | translate
                                    : {
                                          numberOfHiddenEvents: day.numberOfHiddenEvents,
                                          hiddenEventsMoreThanOne: day.numberOfHiddenEvents > 1 ? 's' : '',
                                      }
                        }}
                    </ui-button>

                    <ui-button
                        type="link"
                        (click)="day.shrink()"
                        *ngIf="day.isShowingMoreEventsThanDefault"
                        class="expansion-toggle"
                    >
                        {{ 'dashboard.showLess' | translate }}
                    </ui-button>

                    <div class="no-events" *ngIf="day.isEmpty">
                        {{ 'dashboard.noEventsOn' | translate: { day: (day.date | i18nDate: 'shortWeekdayNoYear') } }}
                    </div>
                </div>

                <!--Next 7 Days Event Grouping -->
                <div class="date" id="next-7-days-heading">{{ 'dashboard.next7Days' | translate }}</div>
                <div role="list" aria-labelledby="next-7-days-heading">
                    <div
                        class="upcoming-event upcoming-event-enhanced"
                        role="listitem"
                        attr.aria-labelledby="next-7-days-event-{{ i }}-title"
                        *ngFor="let event of next7DaysDateGrouping.viewableEvents; let i = index"
                    >
                        <div class="upcoming-event-card">
                            <div class="flex">
                                <div (click)="goToEmployeeProfile(event.employeeId)" class="avatar-container">
                                    <app-avatar size="medium" [employee]="event.pseudoEmployee"></app-avatar>
                                </div>
                                <div
                                    (click)="goToEmployeeProfile(event.employeeId)"
                                    class="upcoming-event-text-container"
                                >
                                    <div class="upcoming-event-title" id="next-7-days-event-{{ i }}-title">
                                        {{ event.upcomingEventTitle | translate: { name: event.fullName } }}
                                    </div>
                                    <div class="upcoming-event-description">
                                        <span *ngIf="event.type === 'timeOffRequests'; else displayStartDate">
                                            <ng-container
                                                [ngTemplateOutlet]="eventDescriptionTemplate"
                                                [ngTemplateOutletContext]="{ event }"
                                            />
                                        </span>
                                        <ng-template #displayStartDate>{{
                                            event.startAt | i18nDate: 'shortNoYear'
                                        }}</ng-template>
                                    </div>
                                </div>
                            </div>
                            <img
                                *ngIf="event.type === 'birthday'"
                                class="event-icon"
                                src="/assets/illustrations/cake.png"
                            />
                            <img
                                *ngIf="event.type === 'anniversary' || event.type === 'newHire'"
                                class="event-icon"
                                src="/assets/illustrations/confetti.png"
                            />
                        </div>
                    </div>
                </div>

                <div class="bottom-card">
                    <ui-button
                        type="link"
                        (click)="next7DaysDateGrouping.expand()"
                        *ngIf="next7DaysDateGrouping.hasHiddenEvents"
                        class="expansion-toggle"
                    >
                        {{
                            'dashboard.showMoreEvents'
                                | translate
                                    : {
                                          numberOfHiddenEvents: next7DaysDateGrouping.numberOfHiddenEvents,
                                          hiddenEventsMoreThanOne:
                                              next7DaysDateGrouping.numberOfHiddenEvents > 1 ? 's' : '',
                                      }
                        }}
                    </ui-button>

                    <ui-button
                        type="link"
                        (click)="next7DaysDateGrouping.shrink()"
                        *ngIf="next7DaysDateGrouping.isShowingMoreEventsThanDefault"
                        class="expansion-toggle"
                    >
                        {{ 'dashboard.showLess' | translate }}
                    </ui-button>

                    <div class="no-events" *ngIf="next7DaysDateGrouping.events.length === 0">
                        {{ 'dashboard.noEventsInTheNext7Days' | translate }}
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #eventDescriptionTemplate let-event="event">
            @if (isPublicView(event)) {
                {{ 'dashboard.away' | translate }}
            } @else {
                <!-- Same Day Event Handling -->
                @if (event.isSameDayEvent) {
                    {{
                        'dashboard.timeOffSameDayDescription'
                            | translate
                                : {
                                      eventDescription:
                                          event.upcomingEventDescription
                                          | translate
                                              : {
                                                    timeOffTypeName: event.payload.timeOffTypeName,
                                                    value:
                                                        (event.payload.displayInHours
                                                            ? event.payload.totalAmountInHours
                                                            : event.payload.totalAmount
                                                        )?.toFixed(2) | i18nNum,
                                                    unit: event.payload.displayInHours
                                                        ? (event.getPluralOrSingularHourlyUnit | translate)
                                                        : (event.getPluralOrSingularDayUnit | translate),
                                                },
                                      date: event.endAt | i18nDate: 'shortNoYear',
                                  }
                    }}
                } @else {
                    <!-- Non-Same-Day Event -->
                    {{
                        event.upcomingEventDescription
                            | translate
                                : {
                                      timeOffTypeName: event?.payload?.timeOffTypeName ?? '',
                                      startAt: event.startAt | i18nDate: 'short',
                                      endAt: event.endAt | i18nDate: 'short',
                                  }
                    }}
                }
            }
        </ng-template>
    </div>
</ui-card>
